const features = [
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
        ),
        title: "AI-Powered Research",
        description: "Access real-time market insights, stock screeners, and AI-driven analysis. Make informed decisions with comprehensive fundamental and technical research tools.",
        gradient: "from-blue-500 to-cyan-500"
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
        ),
        title: "Smart Strategy Building",
        description: "Create sophisticated trading strategies with our AI assistant. From simple moving averages to complex multi-indicator rules — build it all with natural language.",
        gradient: "from-violet-500 to-purple-500"
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        title: "Historical Backtesting",
        description: "Validate your strategies against years of NSE/BSE historical data. Understand risk, returns, and drawdowns before risking real capital.",
        gradient: "from-amber-500 to-orange-500"
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
        ),
        title: "Automated Execution",
        description: "Connect with leading Indian brokers like Zerodha, Upstox, and Angel One. Execute trades automatically with real-time market conditions.",
        gradient: "from-emerald-500 to-teal-500"
    }
];

const FeaturesSection = ({ className = "" }) => {
    return (
        <section className={`py-24 px-4 md:px-12 lg:px-20 bg-base-200/50 ${className}`}>
            <div className="max-w-7xl mx-auto">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <span className="text-sm font-semibold text-primary uppercase tracking-wider">Why Choose Us</span>
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading mt-3 mb-4">
                        <span className="text-base-content">Everything You Need to </span>
                        <span className="text-gradient">Trade Smarter</span>
                    </h2>
                    <p className="text-base-content/60 max-w-2xl mx-auto text-lg">
                        From research to execution, our AI-powered platform gives you the edge in Indian stock markets
                    </p>
                </div>

                {/* Features Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="group relative bg-base-100 rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-base-300/50"
                        >
                            {/* Gradient accent */}
                            <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-300`} />

                            {/* Icon */}
                            <div className={`inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br ${feature.gradient} text-white mb-5 shadow-lg`}>
                                {feature.icon}
                            </div>

                            {/* Content */}
                            <h3 className="text-xl font-bold font-heading text-base-content mb-3">
                                {feature.title}
                            </h3>
                            <p className="text-base-content/60 leading-relaxed">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
